// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"kL-z","smallCardRow":"lL-z","largeCardRow":"mL-z","productSearchRow":"nL-z","curatedRow":"oL-z"};